(function ($, Promise) {

		// Constructor
		function SkillGamesGame3Plane(parent, type) {

			this.parent = parent;

			this.used = false;
			this.state = false;
			this.collisionOccured = false;
			this.landingOccured = false;
			this.outOfScreen = false;

			this.outOfscreenTimeline = false;
			this.launchTimeout = false;

			this.angle = 0;
			this.visibleAngle = 0;
			this.levelSpeed = 1;
			this.planeSpeed = 1;
			this.logicSize = 180;
			this.position = {
				x: 0,
				y: 0,
			}

			this.arrowsAngles = [-Math.PI / 2, -Math.PI / 4, Math.PI / 4, Math.PI / 2];
			this.arrows = [];
			this.graphic = new PIXI.Container();

			this.angleTween = false;

			this.circleATexture = PIXI.Texture.from('images/skill_games/landing_airplanes/airplane-circle-A.png');
			this.circleBTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/airplane-circle-B.png');

			var airplaneTexture = false;
			if (type === "jet") {
				this.planeSpeed = 2;
				airplaneTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/airplane-jet.png');
			} else {
				this.planeSpeed = 1.5;
				airplaneTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/airplane-propeller.png');
			}

			// Circle
			this.circleSprite = new PIXI.Container();
			this.circleSprite = new PIXI.Sprite(this.circleATexture);
			this.circleSprite.scale.set(0.35);
			this.circleSprite.anchor.set(0.5);
			this.graphic.addChild(this.circleSprite);

			// Airplane
			this.airplaneSprite = new PIXI.Sprite(airplaneTexture);
			this.airplaneSprite.scale.set(0.35);
			this.airplaneSprite.anchor.set(0.5);
			this.graphic.addChild(this.airplaneSprite);

			// Arrows
			var airplaneArrowTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/airplane-arrow.png');
			for (var i = 0; i < this.arrowsAngles.length; i++) {

				this.arrows[i] = new PIXI.Container();
				this.arrows[i].interactive = true;
				this.arrows[i].buttonMode = true;
				this.arrows[i].rotation = this.arrowsAngles[i];
				this.arrows[i].x = Math.cos(this.arrowsAngles[i]) * (this.logicSize - 60);
				this.arrows[i].y = Math.sin(this.arrowsAngles[i]) * (this.logicSize - 60);
				this.graphic.addChild(this.arrows[i]);

				var arrowSprite = new PIXI.Sprite(airplaneArrowTexture);
				arrowSprite.anchor.set(0.5);
				arrowSprite.scale.set(0.35);
				this.arrows[i].addChild(arrowSprite);

				this.arrows[i].on('pointerdown', $.proxy(function (angle) {
					if (!this.collisionOccured && !this.landingOccured && !this.outOfScreen) {
						this.setAngle(this.angle + angle);
					}
				}, this, this.arrowsAngles[i]));
			}

		}

		SkillGamesGame3Plane.prototype.startIn = function (delay) {
			if (this.launchTimeout != "false") {
				clearTimeout(this.launchTimeout);
				this.launchTimeout = false;
			}

			this.used = true;

			this.launchTimeout = setTimeout($.proxy(function () {
				this.start();
			}, this), delay);
		}

		SkillGamesGame3Plane.prototype.start = function () {
			this.used = true;
			this.state = true;
		}

		SkillGamesGame3Plane.prototype.stop = function () {
			this.used = false;
			this.state = false;
		}

		SkillGamesGame3Plane.prototype.setAngle = function (value) {

			// Make sur to make smooth rotations
			if (this.angle - value > Math.PI) {
				this.visibleAngle = this.visibleAngle - Math.PI * 2;
			} else if (this.angle - value < -Math.PI) {
				this.visibleAngle = this.visibleAngle + Math.PI * 2;
			}

			// Tween angle to its new value
			this.angleTween = TweenMax.to(this, 0.3, {
				visibleAngle: value,
				easing: Sine.easeInOut,
				onComplete: function () {
					this.visibleAngle = this.angle;
				},
				onCompleteScope: this,
			});

			// this.angle = ((value) % (Math.PI * 2));
			this.angle = ((value + Math.PI) % (Math.PI * 2)) - Math.PI;

			// Make -3.1416 -> 3.1416
			if (this.angle == Math.PI * 2) {
				this.angle = 0;
			}
		}

		SkillGamesGame3Plane.prototype.draw = function (delta) {

			if (this.state == false) {
				this.graphic.visible = false;
				return;
			}

			//  Check screen bounds and reverse angle when out
			// this.keepInScreen()

			//  Check screen bounds and reset planes when out
			this.checkOutOfScreen();

			// Update position
			if (this.collisionOccured == false) {
				var appliedSpeed = (this.landingOccured) ? this.planeSpeed * 0.4 : this.planeSpeed * this.levelSpeed;
				this.position.x += Math.cos(this.angle) * appliedSpeed * delta;
				this.position.y += Math.sin(this.angle) * appliedSpeed * delta;
			}

			// Update visible values
			this.graphic.visible = true;
			this.graphic.x = this.position.x;
			this.graphic.y = this.position.y;
			this.graphic.rotation = this.visibleAngle;
		}

		SkillGamesGame3Plane.prototype.toggleWarning = function (toggle) {

			// TODO If wanted, make the visual warning here

			if (toggle) {
				// this.warningGraphic.alpha = 1;
				// this.warningGraphic.filters[0].color = 0xebc21d;
			} else {
				// this.warningGraphic.alpha = 0;
			}
		}

		SkillGamesGame3Plane.prototype.collision = function () {
			this.collisionOccured = true;

			this.clearAngleTimeline();

			// Animate timeline
			var tl = new TimelineMax();

			// Tween arrows
			for (var i = 0; i < this.arrowsAngles.length; i++) {
				tl.to(this.arrows[i], 0.1, {
					alpha: 0,
					easing: Sine.easeInOut
				}, 0);
				tl.to(this.arrows[i].scale, 0.1, {
					x: 0,
					y: 0,
					easing: Sine.easeInOut
				}, 0);
			}

			// Rotate circle
			tl.fromTo(this.circleSprite, 0.6, {
				rotation: 0,
			}, {
				rotation: 0.4,
				ease: Linear.easeNone
			}, 0);

			// Airplaine itself
			tl.to([this.airplaneSprite, this.circleSprite], 0.35, {
				alpha: 0,
				easing: Sine.easeInOut
			}, 0.25);
			tl.to([this.airplaneSprite.scale, , this.circleSprite.scale], 0.35, {
				delay: 0.25,
				x: 0.2,
				y: 0.2,
				easing: Sine.easeInOut
			}, 0.25);

			// Swap circle texture
			this.circleSprite.texture = this.circleBTexture;

			// Final callback
			tl.addCallback(function () {
				this.stop();
			}, "+=0.0", [], this);

		}

		SkillGamesGame3Plane.prototype.land = function (spot) {
			this.landingOccured = true;

			this.clearAngleTimeline();

			// Animate timeline
			var tl = new TimelineMax();

			// Tween arrows
			for (var i = 0; i < this.arrowsAngles.length; i++) {
				tl.to(this.arrows[i], 0.1, {
					alpha: 0,
					easing: Sine.easeInOut
				}, 0);
				tl.to(this.arrows[i].scale, 0.1, {
					x: 0,
					y: 0,
					easing: Sine.easeInOut
				}, 0);
			}

			// Tween airplane
			tl.to([this.airplaneSprite, this.circleSprite], 0.4, {
				alpha: 0,
				easing: Sine.easeInOut
			}, 0);
			tl.to([this.airplaneSprite.scale, this.circleSprite.scale], 0.4, {
				x: 0.15,
				y: 0.15,
				easing: Sine.easeInOut
			}, 0);

			this.setAngle(spot.graphic.rotation)

			// Final callback
			tl.addCallback(function () {
				this.stop()
			}, "+=0.0", [], this);

		}

		SkillGamesGame3Plane.prototype.hide = function () {
			this.collisionOccured = true;

			if (this.angleTween != false) {
				this.angleTween.kill();
				this.angleTween = false;
			}

			// Animate timeline
			var tl = new TimelineMax();

			// Tween arrows
			for (var i = 0; i < this.arrowsAngles.length; i++) {
				tl.to(this.arrows[i], 0.1, {
					alpha: 0,
					easing: Sine.easeInOut
				}, 0);
				tl.to(this.arrows[i].scale, 0.1, {
					x: 0,
					y: 0,
					easing: Sine.easeInOut
				}, 0);
			}

			// Airplaine itself
			tl.to([this.airplaneSprite, this.circleSprite], 0.35, {
				alpha: 0,
				easing: Sine.easeInOut
			}, 0.25);
			tl.to([this.airplaneSprite.scale, this.circleSprite.scale], 0.35, {
				delay: 0.25,
				x: 0.85,
				y: 0.85,
				easing: Sine.easeInOut
			}, 0.25);

		}

		// SkillGamesGame3Plane.prototype.keepInScreen = function () {
		//
		// 	// Horizontal
		// 	if (this.position.x < 100 && Math.cos(this.angle) < 0) {
		// 		var angle = Math.atan2(Math.sin(this.angle), Math.cos(this.angle) * -1);
		// 		this.setAngle(angle);
		// 	} else if (this.position.x > (1920 - 100) && Math.cos(this.angle) > 0) {
		// 		var angle = Math.atan2(Math.sin(this.angle), Math.cos(this.angle) * -1);
		// 		this.setAngle(angle);
		// 	}
		//
		// 	// Vertical
		// 	if (this.position.y < 200 && Math.sin(this.angle) < 0) {
		// 		var angle = Math.atan2(Math.sin(this.angle * -1), Math.cos(this.angle));
		// 		this.setAngle(angle);
		// 	} else if (this.position.y > (1080 - 100) && Math.sin(this.angle) > 0) {
		// 		var angle = Math.atan2(Math.sin(this.angle * -1), Math.cos(this.angle));
		// 		this.setAngle(angle);
		// 	}
		// }

		SkillGamesGame3Plane.prototype.checkOutOfScreen = function () {
			if (this.outOfScreen) {
				return;
			}

			// Define threshold
			var outOfScreenThreshold = 50;

			// Horizontal
			if (this.position.x < -outOfScreenThreshold && Math.cos(this.angle) < 0) {
				this.setOutOfScreen();
			} else if (this.position.x > (1920 - outOfScreenThreshold) && Math.cos(this.angle) > 0) {
				this.setOutOfScreen();
			}

			// Vertical
			if (this.position.y < outOfScreenThreshold && Math.sin(this.angle) < 0) {
				this.setOutOfScreen();
			} else if (this.position.y > (1080 - outOfScreenThreshold) && Math.sin(this.angle) > 0) {
				this.setOutOfScreen();
			}
		}

		SkillGamesGame3Plane.prototype.setOutOfScreen = function () {
			if (this.outOfScreen) {
				return;
			}

			console.log('setOutOfScreen')
			this.outOfScreen = true;

			// Clear current animations
			this.clearAngleTimeline();
			if (this.outOfscreenTimeline) {
				this.outOfscreenTimeline.kill();
				this.outOfscreenTimeline = false;
			}

			// Animate timeline
			this.outOfscreenTimeline = new TimelineMax();

			// Tween arrows
			this.outOfscreenTimeline.to(this.graphic, 0.2, {
				alpha: 0.3,
				easing: Sine.easeInOut
			}, 0);

			// Final callback
			this.outOfscreenTimeline.addCallback(function () {
				this.stop();
				this.parent.launchAirplane();
			}, 2.0, [], this);

		}

		SkillGamesGame3Plane.prototype.cancelLaunch = function () {
			if (this.launchTimeout != "false") {
				clearTimeout(this.launchTimeout);
				this.launchTimeout = false;
			}
		}

		SkillGamesGame3Plane.prototype.clearAngleTimeline = function () {
			if (this.angleTween != false) {
				this.angleTween.progress(1, false);
				this.angleTween.kill();
				this.angleTween = false;
			}
		}

		SkillGamesGame3Plane.prototype.reset = function () {
			this.used = false;
			this.state = false;
			this.collisionOccured = false;
			this.landingOccured = false;
			this.outOfScreen = false;

			this.graphic.alpha = 1;

			this.airplaneSprite.alpha = 1;
			this.airplaneSprite.scale.set(0.35);

			this.circleSprite.alpha = 1;
			this.circleSprite.scale.set(0.35);
			this.circleSprite.texture = this.circleATexture;

			// this.warningGraphic.alpha = 0;

			this.cancelLaunch();

			this.clearAngleTimeline();

			if (this.outOfscreenTimeline) {
				this.outOfscreenTimeline.kill();
				this.outOfscreenTimeline = false;
			}

			for (var i = 0; i < this.arrowsAngles.length; i++) {
				this.arrows[i].alpha = 1;
				this.arrows[i].scale.set(1);
			}
		}

		// Expose SkillGamesGame3Plane
		window.SkillGamesGame3Plane = SkillGamesGame3Plane;
	}
)
(jQuery, Promise);
